import { render, staticRenderFns } from "./_tab_employees.vue?vue&type=template&id=e9b0a0d0&"
import script from "./_tab_employees.vue?vue&type=script&lang=js&"
export * from "./_tab_employees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports